import React from 'react';
import './DataTablePagination.css';

const DataTablePagination = ({
  currentPage = 1,
  totalRows = 0,
  rowsPerPage = 10,
  onChangePage,
  onChangeRowsPerPage,
  rowsPerPageOptions = [10, 25, 50, 100],
  scrollToTop = false,
}) => {
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const startRow = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const endRow = Math.min(currentPage * rowsPerPage, totalRows);

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      onChangePage(currentPage - 1);
      if (scrollToTop) {
        handleScrollToTop();
      }
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onChangePage(currentPage + 1);
      if (scrollToTop) {
        handleScrollToTop();
      }
    }
  };

  const handlePageClick = (page) => {
    onChangePage(page);
    if (scrollToTop) {
      handleScrollToTop();
    }
  };

  const handleRowsPerPageChange = (e) => {
    onChangeRowsPerPage(parseInt(e.target.value));
    if (scrollToTop) {
      handleScrollToTop();
    }
  };

  const handleFirst = () => {
    if (currentPage > 1) {
      onChangePage(1);
      if (scrollToTop) {
        handleScrollToTop();
      }
    }
  };

  const handleLast = () => {
    if (currentPage < totalPages) {
      onChangePage(totalPages);
      if (scrollToTop) {
        handleScrollToTop();
      }
    }
  };

  return (
    <div className="rdt_Pagination">
      <div className="rdt_PaginationRowsPerPage">
        <div className="rdt_PaginationRowsPerPageLabel">Rows per page:</div>
        <select
          className="rdt_PaginationRowsPerPageSelect"
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
        >
          {rowsPerPageOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>

      <div className="rdt_PaginationRange">
        {startRow}-{endRow} of {totalRows}
      </div>

      <div className="rdt_PaginationNav">
        {/* First Page Button */}
        <button
          className={`rdt_PaginationButton ${
            currentPage === 1 ? "rdt_PaginationButton--disabled" : ""
          }`}
          onClick={handleFirst}
          disabled={currentPage === 1}
          type="button"
          title="First Page"
        >
          <svg
            className="rdt_PaginationIcon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" />
          </svg>
        </button>

        {/* Previous Page Button */}
        <button
          className={`rdt_PaginationButton ${
            currentPage === 1 ? "rdt_PaginationButton--disabled" : ""
          }`}
          onClick={handlePrevious}
          disabled={currentPage === 1}
          type="button"
          title="Previous Page"
        >
          <svg
            className="rdt_PaginationIcon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </button>

        {/* Next Page Button */}
        <button
          className={`rdt_PaginationButton ${
            currentPage === totalPages ? "rdt_PaginationButton--disabled" : ""
          }`}
          onClick={handleNext}
          disabled={currentPage === totalPages}
          type="button"
          title="Next Page"
        >
          <svg
            className="rdt_PaginationIcon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
          </svg>
        </button>

        {/* Last Page Button */}
        <button
          className={`rdt_PaginationButton ${
            currentPage === totalPages ? "rdt_PaginationButton--disabled" : ""
          }`}
          onClick={handleLast}
          disabled={currentPage === totalPages}
          type="button"
          title="Last Page"
        >
          <svg
            className="rdt_PaginationIcon"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default DataTablePagination;
